export enum FormLayoutType {
    DEFAULT = "DEFAULT",
    INLINE = "INLINE",
    TABS = "TABS",
}
